// import { useRouter } from 'next/router'
import { BrowserRouter as Router, Link, NavLink } from "react-router-dom";
// import { NavHashLink } from 'react-router-hash-link';
import { DisplayRoute } from "../routes";
// import Image from 'next/image'
import { atom, useAtom } from 'jotai'
import _ from "lodash"
import { useState, useEffect, useRef, forwardRef } from 'react'
import {preloadedAssetsAtom} from '../atoms/atom.config.js'

import Carousel from 'nuka-carousel';
import { VideoItem } from "../components/VideoItem";
import {OutlineButtonTextIcon, ButtonTextIcon, ButtonIcon, ButtonHoverIcon} from '../components/Button'
import Spinner from '../components/Spinner'
import parse from 'html-react-parser';

// import { isSmallAtom } from "../atoms";
import {isSmallAtom, isAnimationsPausedAtom} from '../atoms/atom.config.js'

import useDeviceSize from '../components/useDeviceSize';
import { mobileWidth, SECTIONS, FEATURES, API,MEDIA, BASE_API } from '../constants';

// assets
import logoImage from '../assets/images/default_thumb.jpg' //button_mobile_menu.svg
// import logoImage2 from './default_thumb.jpg'

// svgr: https://react-svgr.com/docs/next/
// import MobileMenu from '../assets/icons/button_mobile_menu.svg'
// import MobileMenu from '../assets/icons/icon_object.svg'
import menuIcon from '../assets/icons/icon_object.svg'
// import nextIcon from '../assets/icons/icon_next.svg'
import nextIcon from '../assets/icons/button_next.svg'
// import prevIcon from '../assets/icons/icon_previous.svg'
import prevIcon from '../assets/icons/button_back.svg'
import nextIconHover from '../assets/icons/button_next_hover.svg'
import prevIconHover from '../assets/icons/button_back_hover.svg'
import playIcon from '../assets/icons/icon_play_video.svg'
// import zoomIcon from '../assets/icons/icon_openimage.svg'
import zoomIcon from '../assets/icons/button_image_zoom.svg'
import zoomHoverIcon from '../assets/icons/button_image_zoom_hover.svg'
import { ThemeConsumer } from "react-bootstrap/esm/ThemeProvider";


const GalleryItem = forwardRef((props,ref) => {
//const GalleryItem = (props) => {
  //console.log("GalleryItem", props.src)
  const [isLoading, setIsLoading] = useState(true);

  

  // gallery aspect ratio: 133:99. 532x396
  const holderRef = useRef(null)
  const aspectRatio = 532/396; // 1.34343434

  // useEffect(() => {    
  //   console.log("getHeightFromParentWidth", getHeightFromParentWidth())
  // }, [isLoading])

  // the loader doesnt know the width + height of the loading content
  // we know the parent width- so we can calculate the height from aspect ratio
  const getHeightFromParentWidth = () => {
    if(holderRef.current) {
      const galleryWidth = holderRef.current.offsetWidth
      const galleryHeight = Math.ceil(galleryWidth / aspectRatio);// holderRef.current.offsetHeight
      //console.log("holderRef", galleryWidth, galleryHeight)
      return galleryHeight+"px"
    } 
    return "396px"
  };
  
  // const getAnimation = (path) => {
  //   return path + "/0000.png"
  // };
  const cnFade = `${(isLoading) ? '' : 'animate-fadein'}`;
  //const cnLoaderHeight = `${(isLoading) ? 'h-['+getHeightFromParentWidth()+']' : 'h-full'}`
  return (
    // <div className='grid w-[64rem] gap-x-1 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3'>
    // <div className='w-full h-[12rem] md:h-[12rem] lg:h-[24rem] xl:h-[24rem] 2xl:h-[24rem] relative bg-slate-400'>
    <div className='w-full relative' ref={holderRef} onClick={event => props.onClick(event, props.zoomsrc)}>
      {/* {
        props.type == "animation" &&
        <img className='relative object-cover' src={getAnimation(props.src)} alt=""  />
      } */}
      {
        props.type == "video" ?
        // <img className='object-cover absolute z-10' src={playIcon} alt=""  />
        <div className="absolute z-10 w-full h-full flex flex-row flex-wrap items-center justify-center">
          <ButtonIcon text="hello" icon={playIcon} iconSize="36" iconAlt="play" onClick={event => props.onClick(event, props.zoomsrc)} className="transition duration-300 scale-100 hover:scale-110"/>
        </div>
        : props.type == "image" ?
        <div className="absolute z-10 w-full h-full flex flex-row flex-wrap items-end justify-end mt-1">
          <ButtonHoverIcon text="hello" icon={zoomIcon} iconHover={zoomHoverIcon} iconSize="48" iconAlt="zoom" onClick={event => props.onClick(event, props.zoomsrc)} className="mr-0 ml-0" />
          {/* onChange={event => handleChange(event, 'hello', 'world')} */}
        </div>
        : <div></div>
      }
      {/* {isLoading && <div style={{height: getHeightFromParentWidth()}} className='w-full absolute z-10 '><Spinner /></div>} */}
      {isLoading && <div style={{height: getHeightFromParentWidth()}} className='w-full absolute z-10 '></div>}
      <img className='w-full h-full relative object-cover' src={props.src} alt={props.alt} onLoad={() => {
          //setTimeout(() => {
            console.log("GalleryItem imageloaded event")
            setIsLoading(false)
          //},10000);
        }}/>
        { props.type != "animation" && <div id="bottomGradient" className="absolute block h-14 w-full z-0 bottom-0 left-0 opacity-30">
          <div className="h-full w-full bg-gradient-to-t from-black to-transparent "></div>
        </div>}

    </div>
  )
});



// invisible image that preloads- use this instead of GalleryItemDetail if need to preload
const PreloadedGalleryItemDetail = (props) => {

  const onlyLoadFirstGalleryImage = true;
  const renderImagesToDom = true;
  // const [image, setImage] = useState(null);
  const [media, setMedia] = useState([]);

  // save the loaded image paths into a global cache so we dont need to load again
  const [preloadedAssets, setPreloadedAssets] = useAtom(preloadedAssetsAtom);

  const preloadImage = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.onload = function() {
        resolve(img)
      }
      img.onerror = img.onabort = function() {
        reject(src)
      }
      img.src = src
    })
  }

  // requires image json list with "thumb" property
  async function preloadImages(imagesObjectList, imagesList=[], onlyLoadFirstGalleryImage=false) {
    const imagesPromiseList = []
    var globalPreloadedAssets = preloadedAssets
    var hasUpdated = false;
    for (const item of imagesList) {
      if(!globalPreloadedAssets.includes(item)) {
          imagesPromiseList.push(preloadImage(item))
          globalPreloadedAssets.push(item)
          hasUpdated = true
          //console.log("... preloadImage", item, globalPreloadedAssets)
      } else {
          console.log("*global preloadImages already attemped to preload:", item)
      }
    }
    // custom dictionary list
    for (const item of imagesObjectList) {
      if(!globalPreloadedAssets.includes(item["thumb"])) {
        imagesPromiseList.push(preloadImage(item["thumb"]))
        globalPreloadedAssets.push(item["thumb"])
        hasUpdated = true
        // OPTIONAL: we only need the first image from the gallery...
        console.log("!!! loaded image:", item["thumb"])
      }
      if(onlyLoadFirstGalleryImage) {
        //console.log("STOP loading after first!")
        break;
      }
    }

    await Promise.all(imagesPromiseList)

    if(hasUpdated) setPreloadedAssets(globalPreloadedAssets)

    // setTimeout(() => {
      // setAssetsLoaded(true)
    // },10000);
    //setAssetsLoaded(true)
    console.log("!!! preloadImages complete!", imagesPromiseList.length)

    // not using the callback in parent- but adding code just in case for later
    if(props.preloadCB) {
      props.preloadCB("!!! gallery items "+imagesPromiseList.length)
    }
  }

  useEffect(() => {
    if(!props.data ) return

    const maxItems = 10; // there is no array- just objects in the json of images
    let items = []
    console.log("!!! begin load items", maxItems)
    for (let i = 0; i < maxItems; i++) {
      const numId = (i+1).toString()
      const thumb = "media_thumbnail_"+numId
      const filename = "media_filename_"+numId
      const caption = "media_caption_"+numId
      const credit = "media_credit_"+numId
      const mediaType = "media_type_"+numId
      if(props.data[filename] ) {
        //&& props.data[thumb]
        // animations dont have thumbnails?
        //const thumbSrc = (props.data[mediaType] == "animation") ? "assets_5D/Security_Features/3D_federation_star.gif" : props.data[thumb]; //props.data[filename] + "/0000.png" 
        const thumbSrc = (props.data[mediaType] == "animation") ? props.data[filename] : props.data[thumb]; 
        // preload carousel image?
        //const imageElement = new Image();
        //imageElement.src = thumbSrc;
        items.push({"id":i, "thumb":BASE_API+thumbSrc, "filename":BASE_API+props.data[filename], "caption":props.data[caption], "credit":props.data[credit], "type":props.data[mediaType], "subtitle_url":null});
        if(onlyLoadFirstGalleryImage) {
          break;
        }
      }
    }

    // preload the FIRST image from the gallery images array only
    preloadImages(items, [BASE_API+props.data.note_feature_filename], onlyLoadFirstGalleryImage)

    setMedia(items)
    console.log("!!! updated media", items)

  
  }, [])

  return (
    // <div>
    <>
      {/* { media.length > 0 &&
      <img className="inline" src={media[0].thumb} width='100px' height='100px' />
      } */}
      {/* dont think we actually need to render the items to dom if we preload via the js load method? */}
      { renderImagesToDom && 
        media.map((item, index) => 
        <div className="inline" key={"m"+index}>
          <img className="inline w-[2rem] h-[2rem]" src={item.thumb}  />
          <img className='inline w-[2rem] h-[2rem]' src={BASE_API+props.data.note_feature_filename}  />
        </div>
        )
      }
    </>
    // </div>
  )

};

const GalleryItemDetail = (props) => {
//function GalleryItemDetail(props) {
  //console.log(props);
  const [curItem, setCurItem] = useState(0);
  //const [zoomItem, setZoomItem] = useState(0);
  // const [isZoom, setIsZoom] = useState(false);
  const [media, setMedia] = useState([]);
  const [assetsLoaded, setAssetsLoaded] = useState(false)
  const [isSmall, setIsSmall] = useAtom(isSmallAtom);
  const carouselRef = useRef(null)

  const [isAnimationPaused, setAnimationPaused] = useAtom(isAnimationsPausedAtom);

  //let media = [];

  // gallery aspect ratio: 133:99. 532x396
  //const aspectRatio = 532/396; // 1.34343434

  const fadeIn = () => {
    // gallery details has: 1. wavy note image; 2. section subtitile; 3. title; 4. description; 5. carousel; 6. carousel credits
    // need to fade each one by one in sequence
  };

  const getCaption = (item) => {
    //{caption} - {credit}
    //console.log("getCaption", credit, caption)
    if(item["credit"] != "") {
      //parse(media[curItem].caption
      return parse(item["caption"]) + " - " + parse(item["credit"])
    }

    return parse(item["caption"]);
  };
  // cannot use "parse"
  const getCaptionParsed = (caption, credit="") => {
    if(credit !== "") {
      return caption + " - " + credit
    }
    return caption
  };

  const preloadImage = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.onload = function() {
        resolve(img)
      }
      img.onerror = img.onabort = function() {
        reject(src)
      }
      img.src = src
    })
  }

  // requires image json list with "thumb" property
  async function preloadImages(imagesObjectList, imagesList=[], onlyLoadFirstGalleryImage=false) {
    const imagesPromiseList = []
    for (const item of imagesList) {
      imagesPromiseList.push(preloadImage(item))
    }
    // custom dictionary list
    for (const item of imagesObjectList) {
      imagesPromiseList.push(preloadImage(item["thumb"]))
      // OPTIONAL: we only need the first image from the gallery...
      console.log("loaded image:", item["thumb"])
      if(onlyLoadFirstGalleryImage) {
        console.log("STOP loading after first!")
        break;
      }

    }

    await Promise.all(imagesPromiseList)

    // setTimeout(() => {
      // setAssetsLoaded(true)
    // },10000);
    setAssetsLoaded(true)
    console.log("preloadImages complete!", imagesPromiseList.length)

    // not using the callback in parent- but adding code just in case for later
    if(props.preloadCB) {
      props.preloadCB("gallery items "+imagesPromiseList.length)
    }


  }


  useEffect(() => {

    setCurItem(0);
    //setZoomItem(0);

    //setZoomItem(null);
    //console.log("set media items", (props.data == null))
    if(!props.data ) return

    const maxItems = 10; // there is no array- just objects in the json of images
    let items = []
    for (let i = 0; i < maxItems; i++) {
      const numId = (i+1).toString()
      const thumb = "media_thumbnail_"+numId
      const filename = "media_filename_"+numId
      const caption = "media_caption_"+numId
      const credit = "media_credit_"+numId
      const alttext = "media_alt_"+numId
      const mediaType = "media_type_"+numId
      
      if(props.data[filename] ) {
        //&& props.data[thumb]
        // animations dont have thumbnails?
        //const thumbSrc = (props.data[mediaType] == "animation") ? "assets_5D/Security_Features/3D_federation_star.gif" : props.data[thumb]; //props.data[filename] + "/0000.png" 
        const thumbSrc = (props.data[mediaType] == "animation" && !isAnimationPaused) ? props.data[filename] : props.data[thumb]; 
        // preload carousel image?
        //const imageElement = new Image();
        //imageElement.src = thumbSrc;
        items.push({"id":i, "thumb":BASE_API+thumbSrc, "filename":BASE_API+props.data[filename], "alttext":props.data[alttext], "caption":props.data[caption], "credit":props.data[credit], "type":props.data[mediaType], "subtitle_url":null});
      }
    }


    // preload the FIRST image from the gallery images array only?
    // FIXED: using custom preloaded image object now
    // preloadImages(items, [BASE_API+props.data.note_feature_filename], true)

    setMedia(items)
    setAssetsLoaded(true)
    console.log("updated media", items)

    
    // need to listen to state change when animations pause
  }, [isAnimationPaused])

  // useEffect(() => {    
  //   console.log("carouselRef", carouselRef.current)
  //   if(carouselRef.current) {
  //     //const galleryHeight = carouselRef.current.offsetHeight;
  //     console.log("galleryHeight", carouselRef.current.offsetHeight, carouselRef.current.offsetWidth)
  //   }
  // }, [curItem])

  
  // const onVideoZoomEvent = event => {
  //   //console.log("handleScrollTest", isScrolling, event)
  //   console.log("onVideoZoomEvent", event)
  //   setIsZoom(true)

  // }

  const getDescription = () => {
    // iterate the features and get the 
    if(props.data) {
      return props.data.description
    }
    return "..."
  };

  // const getGallery = () => {
  //   const data = []; // props.data;
  //   if(props.data) {
  //     const maxItems = 7;
  //     for (let i = 0; i < maxItems; i++) {
  //       const numId = (i+1).toString()
  //       const thumb = "media_thumbnail_"+numId
  //       const filename = "media_filename_"+numId
  //       const caption = "media_caption_"+numId
  //       const credit = "media_credit_"+numId
  //       const mediaType = "media_type_"+numId
  //       if(props.data[filename] && props.data[thumb]) {
  //         data.push({"id":i, "thumb":BASE_API+props.data[thumb], "filename":BASE_API+props.data[filename], "caption":props.data[caption], "credit":props.data[credit], "type":props.data[mediaType]});
  //       }
  //     }
  //   }
  //   //console.log(data);
  //   return data;
  // };

  const config = {
    pagingDotsStyle: {
      fill: 'white',
      padding: '0.5rem',
      // transform: 'scale(1.5)',
      zIndex: 10
    },
    pagingDotsClassName: 'transition-transform hover:scale-[1.7] scale-150 '
    // nextButtonText: ' ',
    // prevButtonText: ' '
  }

  const single = media.length < 2;
  //const rightPadGallery = (isSmall) ? '' : ' pr-[3rem]'
  //const highlighted = `underline decoration-2 underline-offset-8`;
  //const cn = `block fixed w-screen h-screen top-0 z-[999] bg-rba-gray ${(isFadingOut) ? 'animate-fadeout' : 'animate-fadein'}`;
  const cn = `grid max-w-[72rem] xl:gap-x-10 2xl:gap-x-10 grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 z-10 ${(isSmall) ? '' : ' pr-[3rem]'}`

  return (
    <div className={cn}>
      { assetsLoaded ? <>
        <div className="font-italic text-left text-sm order-last animate-slidexFadeinDelayD">
            { media.length > 0 ?
              <Carousel 
                  //innerRef={carouselRef}
                  // clickDisabled
                  width={'100%'} 
                  wrapAround={ (media.length > 1) }
                  dragging={ (media.length > 1) && false }
                  defaultControlsConfig={config} 
                  afterSlide={index => setCurItem(index)}
                  disableEdgeSwiping={true}
                  //slideIndex={curItem}
                  withoutControls={single}
                  renderCenterLeftControls={({ previousDisabled, previousSlide }) => (
                      <ButtonHoverIcon text="" icon={prevIcon} iconHover={prevIconHover} iconSize="48" iconAlt="previous" onClick={previousSlide} className="mr-0 ml-0 "/>
                      // <button onClick={previousSlide} disabled={previousDisabled}>
                      //   Previous
                      // </button>
                    )}
                  renderCenterRightControls={({ nextDisabled, nextSlide }) => (
                      <ButtonHoverIcon text="" icon={nextIcon} iconHover={nextIconHover} iconSize="48" iconAlt="next" onClick={nextSlide} className="mr-0 ml-0 "/>
                      // <button onClick={nextSlide} disabled={nextDisabled}>
                      // Next
                      // </button>
              )}>
                {
                  media.map((item, index) => 
                  <GalleryItem key={index} src={item.thumb} alt={item.alttext} zoomsrc={item} type={item.type} onClick={props.onZoom}/>
                  )
                }
              </Carousel>
             
              : <div>...</div>
            }

            { media.length > 0 &&
              <p key={curItem} className='mt-6 mb-6 pb-[8.5rem] md:pb-[0rem] min-h-[6rem] px-[2rem] md:px-[0rem] lg:px-[0rem] xl:px-[0rem] 2xl:px-[0rem] text-[0.9rem] md:text-base font-medium animate-fadein'>    
                {/* {parse(media[curItem].caption) + " // " + getCaption(media[curItem]) }    */}
                {parse(media[curItem].caption)} 
                <span className=''>
                { (media[curItem].credit) ? " - " + parse(media[curItem].credit) : ""}
                </span>
                {/* { getCaption(media[curItem]) }   */}
                {/* This is the about page 1. This is the about page 1. This is the about page 1. This is the about page 1. This is the about page 1 */}
              </p>
            }
            
        </div>
        
        {/* px-[2rem] md:px-[0rem] lg:px-[0rem] xl:px-[0rem] 2xl:px-[0rem]  */}
        <div className="text-left pr-[2rem] md:pr-[3rem] lg:pr-[3rem] xl:pr-[3rem] 2xl:pr-[3rem] pl-[2rem] pt-[5rem] md:pt-[0rem] lg:pt-[0rem] xl:pt-[0rem] 2xl:pt-[0rem]">
            <div className="flex flex-row flex-wrap items-center justify-center md:justify-start lg:justify-start xl:justify-start 2xl:justify-start animate-slidexFadeinDelayA">
              <img className='w-[20rem] ml-[-1rem]' src={BASE_API+props.data.note_feature_filename} alt="Magnify zoom feature"  />
            </div>
            <h3 className="text-l font-bold mt-2 uppercase animate-slidexFadeinDelayB">
              {props.subhead && props.subhead}
            </h3>
            <h2 className="text-4xl font-bold mt-2 animate-slidexFadeinDelayB">
              {props.data && parse(props.data.name)}    
            </h2>
            <p className='mt-6 mb-12 font-medium animate-slidexFadeinDelayC'>
            {props.data && parse(props.data.description)} 
            </p>
        </div>

        {/* zoom item */}
        {/* { media.length > 0 && isZoom &&
          <div className="absolute block w-screen h-screen top-0 left-0 z-50 bg-black">     
            <VideoItem
              src={media[curItem].filename}
              caption={media[curItem].caption}
              credit={media[curItem].credit}
              subtitles={media[curItem].subtitle_url}
            />
            </div>
        } */}
      </> :
      <div className='absolute h-full w-screen top-0 left-0'>
      {/* <Spinner icon={props.spinner}/> */}
      </div>
    }
    </div>
    
  )
}

export {
  GalleryItemDetail,
  GalleryItem,
  PreloadedGalleryItemDetail
}
